export const SDK_VERSION = '3.8.10';
